import React from "react";
const ReactRouterDomLink = require("react-router-dom").Link;

export default function CustomLink({
  url, // external
  to = "/", // internal
  children,
  target,
  className,
  onClick,
}) {
  if (url) {
    return (
      <a
        target={target}
        href={url}
        rel="noopener noreferrer"
        onClick={onClick}
        className={className}
      >
        {children}
      </a>
    );
  }

  return (
    <ReactRouterDomLink
      to={to}
      target={target}
      onClick={onClick}
      className={className}
    >
      {children}
    </ReactRouterDomLink>
  );
}
